import type { RefObject } from 'react'
import { useRef } from 'react'
import { useMeasure, useScroll, useScrolling } from 'react-use'

import { getScrollPosition, hasScrollbar, setScroll } from '../ScrollControls'

export const useMeasurements = () => {
  const htmlElement = typeof document !== 'undefined' ? document.createElement('div') : null
  const scroller = useRef(htmlElement)
  const scroll = useScroll(scroller)
  const isScrolling = useScrolling(scroller)
  const [wrapper, wrapperSizes] = useMeasure<HTMLElement>()
  const nextScrollPositions = getNextScrollPositions(scroller)

  const updateScroller = (direction: string) => {
    const scrollerNode = scroller.current
    if (scrollerNode) {
      if (direction === 'next') {
        setScroll({ node: scrollerNode, position: nextScrollPositions.next })
      }
      if (direction === 'previous') {
        setScroll({ node: scrollerNode, position: nextScrollPositions.previous })
      }
    }
  }

  return {
    refs: {
      scroller,
      wrapper,
    },
    isScrollable: hasScrollbar(scroller),
    isScrolling,
    updateScroller,
    scrollPosition: getScrollPosition({ scroller, x: scroll.x, width: wrapperSizes.width }),
  }
}

export const getCardWidth = (ref: RefObject<HTMLElement>) => {
  const current = ref.current
  if (current) {
    const articleEl = current.querySelector('article')
    if (articleEl) {
      const style = window.getComputedStyle(articleEl, null)
      return articleEl.offsetWidth + parseInt(style.getPropertyValue('margin-right'))
    }
  }
  return 0
}

export const getNextScrollPositions = (ref: RefObject<HTMLElement>) => {
  const current = ref.current
  const amount = getCardWidth(ref)
  if (current) {
    return {
      next: current.scrollLeft + amount,
      previous: current.scrollLeft - amount,
    }
  }
  return {
    next: 0,
    previous: 0,
  }
}
